const mutations = {
    updateWindowProperties: (state, payload) => {
        state.window.windowHeight = payload.windowHeight;
        state.window.windowWidth = payload.windowWidth;
    },

    updateWindowScroll: (state, value) => {
        state.window.scrollY = value;
    },

    toggleSearchBoxFocus: (state, focused) => {
        state.inputHasFocus = focused;
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/Screen/mutations.js